<template>
  <div
    class="p-2"
    :class="{ 'show-pinned': !noPinnedHighlight && pinnedColor }"
  >
    <pure-pin-button
      :class="{
        invisible: !(showPinned || pinnedColor)
      }"
      :color="pinnedColor"
      @click="$emit('pinned')"
    />
    <div>
      <p class="text-chplus-title font-bold" :style="{ color: color }">
        {{ title }}
      </p>
      <div
        class="text-chplus-candidate-info text-color-candidate flex flex-col pl-5"
      >
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import PurePinButton from "@/components/buttons/PurePinButton.vue";

export default {
  name: "PersonInfoSlice",
  components: { PurePinButton },
  props: {
    color: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    showPinned: {
      type: Boolean,
      default: false
    },
    noPinnedHighlight: {
      type: Boolean,
      default: false
    },
    pinnedColor: {
      type: String,
      required: false
    }
  }
};
</script>
